import { User } from 'firebase/auth';

interface UserInfoProps {
  user: User | null | undefined;
}

const UserInfo = ({ user }: UserInfoProps) => {
  return (
    <div className="user-info flex items-center pb-2 rounded bg-gray-200">
      <img src={'/icons/user.svg'} alt="User Avatar" className="w-4 h-4 rounded-full mr-1" />
      <div className="overflow-hidden text-ellipsis whitespace-nowrap">
        <p className="text-sm text-neutral-60">{user?.email}</p>
      </div>
    </div>
  );
};

export default UserInfo;
